(function ($) {
  Drupal.behaviors.filterableProductsGridFormatterV1 = {
    isMobile: false,
    unisonDependent: true,
    unisonReady: false,
    attached: false,
    selector: {
      defaultFilter:
        '.js-filterable-products__grid-item-prefilter, .js-filterable-content__grid-item-prefilter',
      container: '.js-filterable-products-block',
      grid: '.js-filterable-products__grid',
      item: '.js-filterable-products__grid-item, .js-filterable-content__grid-item',
      itemInner:
        '.filterable-products__grid-item--content, .filterable-content__grid-item--content',
      filtered: 'js-filterable-products__grid--filtered',
      unfiltered: 'js-filterable-products__grid--unfiltered',
      ctaContainer:
        '.js-filterable-products__grid-item--cta, .js-filterable-content__grid-item--cta',
      itemCTAUrl: '.js-filterable-products__grid-item--cta-url',
      itemATB: '.js-filterable-products__grid-item--add-to-bag',
      itemInvStatus: '.js-filterable-products__grid-item__inventory-status',
      itemPrice: '.js-filterable-products__grid-item--price'
    },

    cssClass: {
      filtered: 'filterable-products__grid--filtered',
      unfiltered: 'filterable-products__grid--unfiltered',
      columnPartial: 'grid-columns--'
    },

    settings: {
      layout: 'masonry',
      itemsPerRowUnfiltered: 7,
      itemsPerRowUnfilteredMobile: 3,
      itemsPerRowFiltered: 5,
      itemsPerRowFilteredMobile: 2,
      firstHero: false,
      firstHeroMobile: false,
      secondHero: false,
      secondHeroMobile: false
    },

    parallaxSettings: {
      itemsPerSlide: 5
    },

    setParallaxSettings: function ($that) {
      var self = this;
      self.parallaxSettings.itemsPerSlide = self.isMobile
        ? $that.data('mobileItemsCount')
        : $that.data('desktopItemsCount');
    },

    attach: function (context) {
      var self = this;

      if (self.attached) {
        return;
      }
      // if Unison is not ready on attach, it triggers change on initialization
      if (!!Unison.fetch.now()) {
        self.isMobile = self.checkIfMobile();
        self.isMedium = self.checkIfMedium();
        self.unisonReady = true;
      }
      Unison.on('change', function () {
        if (!self.attached && self.unisonDependent) {
          // re attach on unisonReady, the initial attach was return
          self.attach(context);
        }
      });
      if (!self.unisonReady && self.unisonDependent) {
        return;
      }
      self.attached = true;
      self.setup(context);
    },

    switchView: function ($that, viewData) {
      if (viewData.view === 'showResults') {
        $that.fadeTo(100, 0, function () {
          $that.addClass('hidden');
          $that.nodes.$container.trigger('filterable_products:initResults', [
            { sku: viewData.sku }
          ]);
        });
        $that.nodes.$container.data('currentView', 'results');
      }
      if (viewData.view === 'showGrid') {
        $that.removeClass('hidden');
        $that.fadeTo(100, 1, function () {
          $that.nodes.$container.trigger('filterable_products:destroyResults');
        });
        $that.nodes.$container.data('currentView', 'grid');
      }
    },

    keepOrder: function ($that) {
      var self = this;

      if (!$that.hasClass('sort-in-progress')) {
        $that.addClass('sort-in-progress');
        $that.isotope({ sortBy: 'default-order' });
      } else {
        $that.removeClass('sort-in-progress');
      }
    },

    setEvents: function ($that) {
      var self = this;

      $that.on('arrangeComplete', function () {
        $that.fadeTo(300, 1, function () {
          if (!$that.hasClass('isotope-initialized')) {
            $that.isotope('reloadItems');
            if ($that.data('preFilterString')) {
              setTimeout(function () {
                self.setState($that);
                $that.isotope({ filter: $that.data('preFilterString') });
              }, 1500);
            }
            self.keepOrder($that);
          }
          $that.addClass('isotope-initialized');
          self.setHero($that);
          $that.isotope('layout');
        });
      });

      $that.on('stateChanged', function () {
        self.setState($that);
      });

      $that.nodes.$container
        .on('filterable_products:newItems', function () {
          // need to parse again for the new items
          self.getDom($that);
          $that.addClass('new-items-processed');
          if ($that.data('gridLayout') === 'parallax_grid') {
            self.initParallaxGrid($that);
          }
        })
        .on('filterable_products:switchView', function (e, eventData) {
          self.switchView($that, eventData);
        });
    },

    initGrid: function ($that) {
      var self = this;

      if ($that.data('gridLayout') !== 'parallax_grid') {
        self.loadIsotopeGrid($that);
      } else {
        self.loadMixItUpGrid($that, false);
      }
    },

    loadIsotopeGrid: function ($that) {
      var self = this;
      var preFilterString = self.selector.defaultFilter;
      $that.isotope({
        // set itemSelector so .grid-sizer is not used in layout
        itemSelector: self.selector.item,
        filter: preFilterString,
        percentPosition: true,
        layoutMode: $that.settings.layout,
        resizesContainer: true,
        getSortData: {
          'default-order': '[data-default-order] parseInt'
        },
        sortBy: 'default-order'
      });
    },
    loadMixItUpGrid: function ($that, isReinit) {
      var self = this;
      var preFilterString = 'all';
      if ($that.data('preFilterString') && $that.data('preFilterString') !== preFilterString) {
        preFilterString = $that.data('preFilterString');
      }
      $that.nodes.$items.hide();
      var mixItUpArgs = {
        animation: {
          enable: !isReinit
        },
        selectors: {
          target: self.selector.item
        },
        layout: {
          display: 'flex'
        },
        load: {
          filter: preFilterString
        }
      };

      if (isReinit) {
        $that.addClass('no-animation');
      }
      $that.on('mixEnd', function (e, state) {
        $that.addClass('mixitup-initialized');
        // MixItUp doesn't seem to work well with 2 diff selectors
        // It doesn't properly set the initial layout value to all items, so we do it from here
        preFilterString === 'all'
          ? $that.nodes.$items.once('initial-display').css({ display: 'flex' })
          : $that.nodes.$items
              .filter(preFilterString)
              .once('initial-display')
              .css({ display: 'flex' });
        setTimeout(function () {
          self.initParallaxGrid($that);
        }, 100);
      });
      $that.on('arrangeComplete', function () {
        self.initParallaxGrid($that);
      });
      $that.mixItUp(mixItUpArgs);
    },

    initParallaxGrid: function ($that) {
      var self = this;
      var hasSlides = $that.nodes.$slides.length;
      var itemsPerSlide = self.parallaxSettings.itemsPerSlide;
      var $tmp = $('<div>').addClass('parallax-slide js-parallax-slide');
      var slideIndex = 0;
      var cardIndex = 0;
      var $slide = hasSlides
        ? $that.nodes.$slides.eq(0)
        : $tmp.clone(true).data('slideIndex', slideIndex);
      var showATB = $that.data('showAtb');
      var showPrice = $that.data('showPrice');

      if (hasSlides) {
        $that.nodes.$slides.removeClass('active has-cards');
      }
      $slide.addClass('active');
      $that.nodes.$filteredSlides = $slide;
      $that.nodes.$items.removeClass('visible').attr('data-card-index', '');

      showATB
        ? $that.nodes.$itemATB.removeClass('hidden') &&
          $that.nodes.$itemInvStatus.removeClass('hidden') &&
          $that.nodes.$itemCTAUrl.addClass('hidden')
        : null;
      showPrice ? $that.nodes.$itemPrice.removeClass('hidden') : null;
      $that.nodes.$items.filter(':visible').each(function (i) {
        var $this = $(this).addClass('visible').attr('data-card-index', cardIndex);
        cardIndex++;
        $slide.addClass('has-cards').appendTo($that);
        $this.appendTo($slide);
        $that.nodes.$slides = hasSlides ? $that.nodes.$slides : $that.nodes.$slides.add($slide);
        $that.nodes.$filteredSlides = $that.nodes.$filteredSlides.add($slide);
        $this.trigger('product.skuSelect', $this.data('skuBaseId'));
        if ((i + 1) % itemsPerSlide === 0) {
          // we need to make a new slide wrapper
          slideIndex++;
          cardIndex = 0;
          $slide = hasSlides
            ? $that.nodes.$slides.eq(slideIndex)
            : $tmp.clone(true).data('slideIndex', slideIndex);
          $slide.addClass('has-cards');
        }
      });

      self.initControlls($that);
      self.generateDots($that);
      $that.addClass('parallax-initialized');
      self.setParallaxEvents($that);
    },

    initControlls: function ($that) {
      var reInit = $that.hasClass('parallax-initialized');

      var $parallaxControlls = !reInit
        ? $('<div>').addClass('parallax-controlls js-parallax-controlls')
        : $that.nodes.$controlls;
      var $parallaxDots = !reInit
        ? $('<ul>').addClass('parallax-dots js-parallax-dots')
        : $that.nodes.$dots;
      if (!reInit) {
        $parallaxControlls.append($('<div>').addClass('prev js-parallax-prev'));
        $parallaxControlls.append($('<div>').addClass('next js-parallax-next'));
        $that.append($parallaxControlls);
        $that.append($parallaxDots);
        $that.nodes.$controlls = $parallaxControlls;
        $that.nodes.$dots = $parallaxDots;
      }
      $that.nodes.$controlls.addClass('hidden');
      if ($that.nodes.$filteredSlides.length > 1) {
        $that.nodes.$controlls.removeClass('hidden');
      }
    },

    generateDots: function ($that) {
      $that.nodes.$dots.empty();
      for (var i = 0; i < $that.nodes.$filteredSlides.length; i++) {
        $that.nodes.$dots.append($('<li>').addClass('dot js-parallax-dot'));
      }
      $that.nodes.$dot = $that.nodes.$dots.find('.js-parallax-dot');
      $that.nodes.$dot.first().addClass('active');
    },

    setParallaxEvents: function ($that) {
      var self = this;
      $that.nodes.$controlls
        .find('.js-parallax-next')
        .once()
        .on('click', function () {
          if ($that.hasClass('transitioning')) {
            return;
          }
          self.initAnimation($that, 'next');
          self.swapActiveDot($that, 'next');
        });
      $that.nodes.$controlls
        .find('.js-parallax-prev')
        .once()
        .on('click', function () {
          if ($that.hasClass('transitioning')) {
            return;
          }
          self.initAnimation($that, 'prev');
          self.swapActiveDot($that, 'prev');
        });
      $that.nodes.$items.on('click', function (e) {
        $(this).find('.filterable-products__grid-item--image').css('transition', 'all 0s');
        self.swapMainCard($(this), $that);
      });
      $that.nodes.$items.on('mouseover', function () {
        $(this).find(self.selector.itemInner).addClass('hover');
      });
      $that.nodes.$items.on('mouseout', function () {
        $(this).find(self.selector.itemInner).removeClass('hover');
      });
      var swipedir;
      var startX;
      var startY;
      var dist = 0;
      $that.nodes.$slides.on('touchstart', function (e) {
        var touchobj = e.originalEvent.changedTouches[0];
        startX = touchobj.pageX;
        startY = touchobj.pageY;
      });
      $that.nodes.$slides.on(
        'touchmove',
        function (e) {
          e.preventDefault();
        },
        { passive: false }
      );
      $that.nodes.$slides.on('touchend', function (e) {
        var touchobj = e.originalEvent.changedTouches[0];
        distX = touchobj.pageX - startX;
        distY = touchobj.pageY - startY;
        if (Math.abs(distX) >= 50 && Math.abs(distY) <= 50) {
          distX < 0
            ? (self.initAnimation($that, 'next'), self.swapActiveDot($that, 'next'))
            : (self.initAnimation($that, 'prev'), self.swapActiveDot($that, 'prev'));
        }
      });
    },

    getMainCard: function ($that) {
      var self = this;
      return self.getCurrentSlide($that).find('[data-card-index="0"]');
    },

    swapMainCard: function ($swapCard, $that) {
      var self = this;
      var $mainCard = self.getMainCard($that);
      $mainCard.attr('data-card-index', $swapCard.attr('data-card-index'));
      $swapCard.find(self.selector.itemInner).removeClass('hover');
      $swapCard.attr('data-card-index', 0);
      setTimeout(function () {
        $swapCard
          .find('.filterable-products__grid-item--image')
          .css('transition', 'all 0.5s ease-in-out');
      }, 0);
    },

    swapActiveDot: function ($that, direction) {
      var $activeDot = $that.nodes.$dots.find('.active');
      direction === 'next'
        ? $that.nodes.$dot.last().hasClass('active')
          ? $that.nodes.$dot.first().addClass('active')
          : $activeDot.next().addClass('active')
        : $that.nodes.$dot.first().hasClass('active')
        ? $that.nodes.$dot.last().addClass('active')
        : $activeDot.prev().addClass('active');
      $activeDot.removeClass('active');
    },

    initAnimation: function ($that, direction) {
      var self = this;
      var $animateElem = direction === 'next' ? self.getNextSlide($that) : self.getPrevSlide($that);
      $that.addClass('transitioning slide-' + direction);
      setTimeout(function () {
        $animateElem.addClass('sliding');
        setTimeout(function () {
          $that.removeClass('transitioning slide-' + direction);
          $that.nodes.$slides.removeClass('active');
          $animateElem.toggleClass('active sliding');
          // delay is dependent on css delay
        }, 5010);
      }, 500);
    },

    getCurrentSlide: function ($that) {
      return $that.nodes.$slides.filter('.active');
    },

    getNextSlide: function ($that) {
      var self = this;
      var $currentSlide = self.getCurrentSlide($that);
      var $nextSlide = $currentSlide.next('.has-cards');
      var isLast =
        $that.nodes.$filteredSlides.index($currentSlide) === $that.nodes.$filteredSlides.length - 1;

      if ($nextSlide.length < 1 && !isLast) {
        $nextSlide = $that.nodes.$slides.first().next('.has-cards');
      } else if ($nextSlide.length < 1) {
        $nextSlide = $that.nodes.$filteredSlides.first();
      }

      return $nextSlide;
    },

    getPrevSlide: function ($that) {
      var self = this;
      var $currentSlide = self.getCurrentSlide($that);
      var $prevSlide = $currentSlide.prev('.has-cards');
      var isFirst = $that.nodes.$filteredSlides.index($currentSlide) === 0;

      if ($prevSlide.length < 1 && !isFirst) {
        $prevSlide = $that.nodes.$slides.last().prev('.has-cards');
      } else if ($prevSlide.length < 1) {
        $prevSlide = $that.nodes.$filteredSlides.last();
      }

      return $prevSlide;
    },

    getSettings: function ($that) {
      var self = this;

      $that.settings = {};
      $that.settings.layout = $that.data('gridLayout') || self.settings.layout;
      $that.settings.itemsPerRowUnfiltered =
        $that.data('unfilteredColumns') || self.settings.itemsPerRowUnfiltered;
      $that.settings.itemsPerRowUnfilteredMobile =
        $that.data('unfilteredColumnsMobile') || self.settings.itemsPerRowUnfilteredMobile;
      $that.settings.itemsPerRowFiltered =
        $that.data('filteredColumns') || self.settings.itemsPerRowFiltered;
      $that.settings.itemsPerRowFilteredMobile =
        $that.data('filteredColumnsMobile') || self.settings.itemsPerRowFilteredMobile;

      $that.settings.firstHero = $that.data('firstHeroPosition') || self.settings.firstHero;
      $that.settings.firstHeroMobile =
        $that.data('firstHeroPositionMobile') || self.settings.firstHeroMobile;
      $that.settings.secondHero = $that.data('secondHeroPosition') || self.settings.secondHero;
      $that.settings.secondHeroMobile =
        $that.data('secondHeroPositionMobile') || self.settings.secondHeroMobile;
    },

    setHerosLayout: function ($that) {
      var self = this;
      if ($that.data('gridLayout') === 'parallax_grid') {
        return;
      }
      if (!self.isMobile) {
        self.cssClass.firstHero = !!$that.data('firstHeroLayout')
          ? $that.data('firstHeroLayout') + '-hero'
          : 'square-hero';
        self.cssClass.secondHero = !!$that.data('secondHeroLayout')
          ? $that.data('secondHeroLayout') + '-hero'
          : 'square-hero';
      } else {
        self.cssClass.firstHero = !!$that.data('firstHeroLayoutMobile')
          ? $that.data('firstHeroLayoutMobile') + '-hero'
          : 'square-hero';
        self.cssClass.secondHero = !!$that.data('secondHeroLayoutMobile')
          ? $that.data('secondHeroLayoutMobile') + '-hero'
          : 'square-hero';
      }
    },

    setup: function (context) {
      var self = this;
      var $grids = $(self.selector.grid, context);

      Unison.on('change', function () {
        self.isMobile = self.checkIfMobile();
        self.isMedium = self.checkIfMedium();
        $grids.trigger('stateChanged');
      });
      $grids.each(function () {
        var $this = $(this);

        self.getDom($this);
        self.getSettings($this);
        self.setState($this);
        self.setEvents($this);
        self.initGrid($this);
      });
    },

    getDom: function ($that) {
      var self = this;

      $that.nodes = $that.nodes || {};
      $that.nodes.$container = $that.closest(self.selector.container);
      $that.nodes.$items = $(self.selector.item, $that);
      $that.nodes.$itemImages = $that.nodes.$items.find('img');
      $that.nodes.$controlls = $that.nodes.$controlls || $();
      $that.nodes.$slides = $that.nodes.$slides || $();
      $that.nodes.$dots = $that.nodes.$dots || $();
      $that.nodes.$dot = $that.nodes.$dot || $();
      $that.nodes.$ctaContainer = $(self.selector.ctaContainer, $that);
      $that.nodes.$itemCTAUrl = $(self.selector.itemCTAUrl, $that);
      $that.nodes.$itemATB = $(self.selector.itemATB, $that);
      $that.nodes.$itemInvStatus = $(self.selector.itemInvStatus, $that);
      $that.nodes.$itemPrice = $(self.selector.itemPrice, $that);
    },

    checkIfMobile: function () {
      var currentBpWidth = parseInt(Unison.fetch.now().width, 10);
      var bPlargeUp = parseInt(Unison.fetch.all()['usn-medium'], 10);

      return currentBpWidth <= bPlargeUp;
    },

    checkIfMedium: function () {
      if (!!Unison.fetch.now()) {
        var currentBpWidth = parseInt(Unison.fetch.now().width, 10);
        var bPlargeUp = parseInt(Unison.fetch.all()['usn-large'], 10);

        return currentBpWidth <= bPlargeUp;
      }

      return false;
    },

    setState: function ($that) {
      var self = this;
      if ($that.data('gridLayout') === 'parallax_grid') {
        self.setParallaxSettings($that);
        self.initParallaxGrid($that);
        return;
      }
      self.resetItemsPerRow($that);
      if ($that.hasClass(self.cssClass.filtered)) {
        self.resetFilteredTemplate($that);
      } else {
        self.setUnfilteredTemplate($that);
      }
      self.setHerosLayout($that);
      self.setHero($that);
    },

    setUnfilteredTemplate: function ($that) {
      // initial grid layout
      var self = this;
      var itemsPerRowKey =
        self.isMobile || self.isMedium ? 'itemsPerRowUnfilteredMobile' : 'itemsPerRowUnfiltered';
      var itemsPerRow = $that.settings[itemsPerRowKey];

      $that.nodes.$items.addClass(self.cssClass.columnPartial + itemsPerRow.toString());
    },

    resetFilteredTemplate: function ($that) {
      // reset grid after filter
      var self = this;
      var itemsPerRowKey =
        self.isMobile || self.isMedium ? 'itemsPerRowFilteredMobile' : 'itemsPerRowFiltered';
      var itemsPerRow = $that.settings[itemsPerRowKey];

      $that.nodes.$items.addClass(self.cssClass.columnPartial + itemsPerRow.toString());
    },

    resetItemsPerRow: function ($grid) {
      var self = this;

      self.removeClass($grid.nodes.$items, self.cssClass.columnPartial);
    },

    removeClass: function ($nodes, classString) {
      return $nodes.removeClass(function (index, classes) {
        var classesArray = classes.split(' '),
          removeClass = _.filter(classesArray, function (className) {
            return className.indexOf(classString) === 0;
          }).toString();

        return removeClass;
      });
    },

    setHero: function ($that) {
      var self = this;

      $that.nodes.$items.removeClass('square-hero rectangle-hero');
      if (!$that.hasClass(self.selector.filtered)) {
        self.redoItemsHeight($that);

        return;
      }
      var firstHeroKey = self.isMobile || self.isMedium ? 'firstHeroMobile' : 'firstHero';
      var secondHeroKey = self.isMobile || self.isMedium ? 'secondHeroMobile' : 'secondHero';
      var firstHeroIndex = $that.settings[firstHeroKey];
      var secondHeroIndex = $that.settings[secondHeroKey];

      if (firstHeroIndex > 0) {
        // reduce by 1 both indexes to equal the correct items obj index
        firstHeroIndex--;
        $that.nodes.$items.filter(':visible').eq(firstHeroIndex).addClass(self.cssClass.firstHero);
      }
      if (secondHeroIndex > 0) {
        // reduce by 1 both indexes to equal the correct items obj index
        secondHeroIndex--;
        $that.nodes.$items
          .filter(':visible')
          .eq(secondHeroIndex)
          .addClass(self.cssClass.secondHero);
      }
      self.redoItemsHeight($that);
    },

    redoItemsHeight: function ($that) {
      // reset the height first so new hero's get the right value
      $that.nodes.$items.css({ height: '' });
      // inline height required for masonry layout, due to aspect ratio on the items
      // not being rounded up
      $that.nodes.$items.map(function () {
        $(this).css({ height: $(this).height() + 'px' });
      });
      if ($that.hasClass('isotope-initialized')) {
        $that.isotope('layout');
      }
    }
  };
})(jQuery);
